module.exports = __webpack_public_path__ + "static/media/personalization.e7fd8e73.svg";